import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import reduxForm from 'redux-form/es/reduxForm';
import isEmpty from 'lodash/isEmpty';
import { getUserSession, getCustomerConsents } from 'actions/authentication';
import {
  goBackToIncomePage,
  handleSubmitLoanStepError,
  loanFormSetStep,
  loanFormStepBack,
  pushGaStepEvent,
  saveLoanForm,
  skipNordigenStep,
  submitInitLoanStep,
  submitLoanStep,
  triggerEmail,
} from 'actions/loan';
import Button from 'components/common/Button';
import LoanError from 'components/Credit24/LoanApplication/LoanError';
import LoanFormFooter from 'components/Credit24/LoanApplication/LoanFormFooter';
import LoanStepError from 'components/Credit24/LoanApplication/LoanStepError';
import LoanFormFooterMW from 'components/Credit24/MobileWallet/LoanFormFooter';
import { asyncValidate, validate } from 'utils/validation/ee';
import { validateLV } from 'utils/validation/lv';
import { validateFI } from 'utils/validation/fi';
import validateLT from 'utils/validation/lt/validateLoan';
import validateAU from 'utils/validation/au/validateLoan';
import queryStringParser from '../../../utils/queryStringParser';

const propTypes = {
  loan: PropTypes.object.isRequired,
  authentication: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  getUserSession: PropTypes.func.isRequired,
  submitLoanStep: PropTypes.func.isRequired,
  submitInitLoanStep: PropTypes.func.isRequired,
  loanFormSetStep: PropTypes.func.isRequired,
  pushGaStepEvent: PropTypes.func.isRequired,
  saveLoanForm: PropTypes.func.isRequired,
  loanFormStepBack: PropTypes.func.isRequired,
  skipNordigenStep: PropTypes.func.isRequired,
  goBackToIncomePage: PropTypes.func.isRequired,
  triggerEmail: PropTypes.func.isRequired,
  getCustomerConsents: PropTypes.func.isRequired,
  children: PropTypes.any,
};

class LoanFormContainer extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.tryAgain = this.tryAgain.bind(this);
  }

  componentDidMount() {
    const { authentication, authentication: { identificationState } } = this.props;
    const { ocm } = queryStringParser.parse(location.search);

    if (INCREASE_APP) {
      if (authentication.isAuthenticated && !isEmpty(authentication.contracts)) {
        this.props.submitInitLoanStep(
          this.props.authentication.channel,
          this.props.loan.product.frontPagePrincipal,
          this.props.authentication.contracts[0]
        );
      }
      return;
    }
    if (authentication.isAuthenticated && isEmpty(authentication.contracts)) {
      if (COUNTRY !== 'FI') {
        this.props.getUserSession();
      }
      let shouldSubmitInitLoanStep = true;
      if (COUNTRY === 'LT') {
        // for LT this should be done only when identificationState is received
        // 'NOT_STARTED_YET' is identificationState of LT migrated legacy customer
        // who has already set a password
        // TODO: check its usage with while working on next steps of the application
        // shouldSubmitInitLoanStep = identificationState === 'IDENTIFIED' ||
        // identificationState === 'NOT_STARTED_YET';

        // shouldSubmitInitLoanStep = authentication.forwardToApplication;
      }

      if (COUNTRY === 'AU') {
        shouldSubmitInitLoanStep = identificationState && identificationState !== 'NOT_STARTED_YET';
      }

      const isOcmProcess = shouldSubmitInitLoanStep && ocm;

      if (isOcmProcess) {
        this.props.submitInitLoanStep(
          this.props.authentication.channel,
          this.props.loan.product.frontPagePrincipal
        );

        return;
      }

      if (shouldSubmitInitLoanStep) {
        this.props.getCustomerConsents(
          this.props.authentication.channel,
          this.props.loan.product.frontPagePrincipal
        );
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { identificationState } = nextProps.authentication;
    let shouldSubmitInitLoanStep = false;
    if (COUNTRY === 'LT') {
      // TODO: check its usage with while working on next steps of the application

      // // 'NOT_STARTED_YET' is identificationState of LT migrated legacy customer
      // // who has already set a password
      // shouldSubmitInitLoanStep = (
      //   !this.props.authentication.identificationState
      //   && (identificationState === 'IDENTIFIED' || identificationState === 'NOT_STARTED_YET')
      // );
    }
    if (COUNTRY === 'AU') {
      shouldSubmitInitLoanStep = (
        (
          !this.props.authentication.identificationState
          || this.props.authentication.identificationState === 'NOT_STARTED_YET'
        )
        && identificationState
        && identificationState !== 'NOT_STARTED_YET'
      );
    }
    if (shouldSubmitInitLoanStep) {
      this.props.submitInitLoanStep(
        nextProps.authentication.channel,
        nextProps.loan.product.frontPagePrincipal
      );
    }

    if (nextProps.loan.canPutFinancialData && !this.props.loan.canPutFinancialData) {
      this.props.submitLoanStep('FINANCIAL_DATA', nextProps.loan.financialData, nextProps.loan);
    }

    if (nextProps.loan.checkExternalPolicies && !this.props.loan.checkExternalPolicies) {
      this.props.submitLoanStep('REGISTRIES_LT', {}, nextProps.loan);
    }

    const index = nextProps.loan.currentStep;
    if (this.props.loan.currentStep > 0 && index > 0 && this.props.loan.currentStep !== index) {
      this.props.saveLoanForm();
    }
  }

  componentDidUpdate(prevProps) {
    const errorMessage = this.getErrorMessage(this.props.loan, this.props.authentication);
    if (COUNTRY === 'LT' && !prevProps.loan.rejected && this.props.loan.rejected) {
      this.props.saveLoanForm();
    }

    if (errorMessage) {
      if (errorMessage.startsWith('offer.rejected.') && !prevProps.loan.rejected) {
        if (COUNTRY === 'AU') {
          this.props.pushGaStepEvent('rejected');
        }
      }
    }
  }

  onSubmit(data) {
    const { loan } = this.props;
    const { currentStep } = loan;
    const { type } = loan.steps[currentStep];
    this.props.submitLoanStep(type, data, loan);
    if (COUNTRY === 'LV' && INSTANTOR_ENABLED) {
      const sendEmail = type === 'INSTANTOR' || (type === 'ONE_CENT' && loan.verifyOptions === 'onecent');
      if (sendEmail) {
        this.props.triggerEmail();
      }
    }
  }

  getFiRejectionMessage(message) {
    switch (true) {
      case /debtRegistry SAT/.test(message):
        return 'debtRegistry.sat';
      case /debtRegistry SOLIDITET/.test(message):
        return 'debtRegistry.soliditet';
      case /noCreditAllowed SOLIDITET/.test(message):
        return 'noCreditAllowed.soliditet';
      default:
        return null;
    }
  }

  getErrorMessage(loan, authentication) {
    if (loan.state !== 'OPEN' && COUNTRY === 'EE') {
      return 'offer.submit.pending';
    }
    if (loan.state !== 'OPEN' && COUNTRY === 'LV'
      && !authentication.registerData.pendingIdentificationRequest
      && authentication.registerData.isLoaded
    ) {
      return 'offer.submit.pending';
    }
    if (loan.rejected) {
      if (
        COUNTRY === 'FI'
        && loan.rejectedMessage
        && this.getFiRejectionMessage(loan.rejectedMessage)
      ) {
        return `offer.rejected.${this.getFiRejectionMessage(loan.rejectedMessage)}`;
      }
      if (COUNTRY === 'AU') {
        if (INCREASE_APP) {
          if (loan.productType === 'CREDIT_LINE' && loan.rejectedMessage === 'DECISION_ENGINE_REJECTION') {
            return 'offer.rejected.upgrade';
          }
        }
        return 'offer.rejected.other.loans';
      }
      return `offer.rejected.${loan.rejected.toLowerCase()}`;
    }
    return null;
  }

  tryAgain() {
    window.location.reload();
  }

  render() {
    const { loan, authentication, children } = this.props;
    const { handleSubmit } = this.props;
    let isTechnicalError = false;

    if (!authentication.isAuthenticated) {
      return null;
    }
    if (COUNTRY === 'LV' || COUNTRY === 'AU') {
      isTechnicalError = loan.technicalError;
    }

    const errorMessage = this.getErrorMessage(loan, authentication);

    if (isTechnicalError) {
      return (
        <LoanStepError
          title={<FormattedMessage id="aio.request_error.title" />}
          text={<FormattedMessage id="aio.request_error.body" />}
          button={(
            <Button
              type="button"
              onClick={this.tryAgain}
            >
              <FormattedMessage id="income_verification.button.retry" />
            </Button>
          )}
        />
      );
    }
    if (errorMessage) {
      if (COUNTRY === 'AU' && loan.channel === 'OCM-WEB') {
        return null;
      }

      return (
        <LoanError
          backToIncome={this.props.goBackToIncomePage}
          errorMessage={errorMessage}
          productType={loan.productType}
        />
      );
    }

    const Content = React.Children.map(children, (child) =>
      React.cloneElement(child, {
        loan,
        authentication,
        loanFormSetStep: this.props.loanFormSetStep,
        pushGaStepEvent: this.props.pushGaStepEvent,
      }));

    return (
      <div className="container container--mobile-fullWidth">
        <form className="loan-form" onSubmit={handleSubmit(this.onSubmit)}>
          {Content || <div className="loan-form__step" />}
          {loan.isLoanFormFooterVisible && (
            MOBILE_WALLET
              ? <LoanFormFooterMW loan={loan} />
              : (
                <LoanFormFooter
                  loan={loan}
                  loanFormStepBack={this.props.loanFormStepBack}
                  skipNordigenStep={() => this.props.skipNordigenStep(true)}
                />
              )
          )}
        </form>
      </div>
    );
  }
}

LoanFormContainer.propTypes = propTypes;
LoanFormContainer.contextTypes = {
  router: PropTypes.object,
};

const shouldAsyncValidate = (params) => {
  if (!params.syncValidationPasses) {
    return false;
  }

  const { trigger } = params;

  return trigger === 'blur' || trigger === 'submit';
};

const formConfigEE = {
  validate,
  asyncValidate,
  shouldAsyncValidate,
};

const formConfigLV = {
  validate: validateLV,
};

const formConfigFI = {
  validate: validateFI,
  asyncValidate,
  shouldAsyncValidate,
};

const formConfigLT = {
  validate: validateLT,
};

const formConfigAU = {
  validate: validateAU,
};

const sharedFormConfig = {
  form: 'loan',
  shouldValidate: () => true,
  onSubmitFail: (errors, dispatch, submitErrors, props) => {
    if (DEBUG) {
      console.warn('form submit fail', errors);
    }
    if (errors) {
      const { loan } = props;
      const action = handleSubmitLoanStepError(loan.steps[loan.currentStep].type, errors, loan);
      if (action) {
        dispatch(action);
      }
    }
  },
};

let formConfig;

switch (COUNTRY) {
  case 'LV':
    formConfig = formConfigLV;
    break;
  case 'FI':
    formConfig = formConfigFI;
    break;
  case 'LT':
    formConfig = formConfigLT;
    break;
  case 'AU':
    formConfig = formConfigAU;
    break;
  default:
    formConfig = formConfigEE;
}

export default reduxForm({
  ...sharedFormConfig,
  ...formConfig,
  shouldValidate: () => true,
})(connect(
  (state) => ({
    loan: state.loan,
    authentication: state.authentication,
  }),
  {
    getUserSession,
    submitLoanStep,
    submitInitLoanStep,
    loanFormSetStep,
    pushGaStepEvent,
    saveLoanForm,
    loanFormStepBack,
    goBackToIncomePage,
    handleSubmitLoanStepError,
    triggerEmail,
    skipNordigenStep,
    getCustomerConsents,
  }
)(LoanFormContainer));
